import { CourseSchedule } from './../../shared-components/student/course-schedule.model';
import { Observable } from 'rxjs';
import { System } from './../../shared-components/System';
import { StudentService } from './../../shared-components/student/student.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { YearService } from '../../shared-components/year/year.service';
import { UserService } from '../../shared-components/user/user.service';

@Injectable()
export class StudentScheduleService {

    // Properties

    // Class Functions
    constructor (
        private http: HttpClient,
        private studentService: StudentService,
        private yearService: YearService,
        private userService: UserService
    ) {}

    // Methods
    getStudentSchedule(
        viewOption: number,
        includeAttendance = false,
        includeReportCardGards = false,
        isProgressGrades = false,
        includeDropped = false,
        includeWithdrawnStudent = false,
        blnIncludeTerms = false,
        showAllAttendanceCodes = false
    ): Observable<CourseSchedule[]> {
        const queryString = '?studentId=' + this.studentService.selectedStudent.Id +
            '&yearId=' + this.yearService.student360Year.Id +
            '&userId=' + this.userService.currentUser.Id +
            '&viewOption=' + viewOption +
            '&includeAttendance=' + includeAttendance +
            '&includeReportCardGrades=' + includeReportCardGards +
            '&isProgressGrades=' + isProgressGrades +
            '&includeDropped=' + includeDropped +
            '&includeWithdrawnStudent=' + includeWithdrawnStudent +
            '&blnIncludeTerms=' + blnIncludeTerms +
            '&showAllAttendanceCodes=' + showAllAttendanceCodes;
        return this.http.get<CourseSchedule[]>(System.apiURL.Student + 'GetStudentSchedule' + queryString);
    }
}
